var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadFormIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#5EA1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13.5C9 13.2239 9.22386 13 9.5 13L20.5 13C20.7761 13 21 13.2239 21 13.5C21 13.7761 20.7761 14 20.5 14L9.5 14C9.22386 14 9 13.7761 9 13.5Z",
    fill: "#5EA1F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.5C9 10.2239 9.22386 10 9.5 10L20.5 10C20.7761 10 21 10.2239 21 10.5C21 10.7761 20.7761 11 20.5 11L9.5 11C9.22386 11 9 10.7761 9 10.5Z",
    fill: "#5EA1F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5C9 16.2239 9.22386 16 9.5 16L16.5 16C16.7761 16 17 16.2239 17 16.5C17 16.7761 16.7761 17 16.5 17L9.5 17C9.22386 17 9 16.7761 9 16.5Z",
    fill: "#5EA1F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20C14 19.4477 14.4477 19 15 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H15C14.4477 21 14 20.5523 14 20Z",
    fill: "#5EA1F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H8C7.44772 7 7 7.44772 7 8V22C7 22.5523 7.44772 23 8 23H22C22.5523 23 23 22.5523 23 22V8C23 7.44772 22.5523 7 22 7ZM8 6C6.89543 6 6 6.89543 6 8V22C6 23.1046 6.89543 24 8 24H22C23.1046 24 24 23.1046 24 22V8C24 6.89543 23.1046 6 22 6H8Z",
    fill: "#5EA1F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadFormIcon);
export default __webpack_public_path__ + "static/media/leadForm_icon.cb30e08bbb8207234b68cca7fd39d624.svg";
export { ForwardRef as ReactComponent };